<div class="textarea-counter" *ngIf="showTextLength">
  <small>
    <span class="current">
      {{ control?.value?.length || 0 }}
    </span>
    z
    <span class="total">
      {{ maxTextLength }}
    </span>
    znaków
  </small>
</div>
<p class='invalid-feedback' *ngIf='error$ | async as error'>
  {{ error }}
  <ng-content></ng-content>
</p>

